import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/pin-location.svg'
import _imports_1 from '@/assets/icons/house-icon.svg'
import _imports_2 from '../../assets/icons/user.svg'
import _imports_3 from '@/assets/images/house-sample-2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-25c96f72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sole-trader-data-wrapper" }
const _hoisted_2 = { class: "form__wrapper" }
const _hoisted_3 = { class: "modal_input_wrapper" }
const _hoisted_4 = { class: "modal_input" }
const _hoisted_5 = {
  key: 0,
  class: "map__wrapper",
  id: "map_properties"
}
const _hoisted_6 = {
  key: 1,
  class: "map__wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please Select Property", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "property__list__wrapper" }
const _hoisted_10 = { class: "property_location" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "property_content" }
const _hoisted_13 = { class: "property_name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "md:!tw-text-[10px]" }
const _hoisted_16 = { class: "property_info" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "property_type" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "property_img md:!tw-min-w-[70px] md:!tw-h-[70px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "tw-w-full tw-max-w-full"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "img-count" }, "1")
], -1))

import { computed, ref, onBeforeMount } from "vue";
import CommonDialog from "@/core/components/CommonDialog.vue";
import { useStore } from "vuex";
import { JOBS_STORE } from "@/store/modules/jobs";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import AddressMapComponent from "@/core/components/AddressMapComponent.vue";
import Button from "../components/ui/general/Button.vue";
import { watch } from "vue";
import { parseJSON } from "../utils/common";
import { LatLngExpression } from "leaflet";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPropertyDialog',
  props: {
  phaseIndex: {
    type: Number,
  },
  taskIndex: {
    type: Number,
  },
},
  emits: ["on-save-task-properties", "on-click-close-tab"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const props = __props;
const modelDetails = ref({
  id: 2,
  tab: "Property",
  name: "Property",
  header: "Property",
  title: "Add or remove property",
  description: "",
});
const propertyFormRef = ref(null) as any;
const selectedProperty = ref([]);
const addresses: any = ref([]);
const sendAddress: any = ref({});
const emits = __emit;
const matchedAddresses: any = ref([]);
const validation = ref({
  propertyId: [(v: any) => !!v || "Select one property"],
});
const estimateForm = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/estimateForm`]
);
const onClickBackButton = () => {
  return emits("on-click-close-tab");
};

const removeProperties = async (id: number) => {
  try {
    await store.dispatch(`${JOB_TEMPLATE_STORE}/removeEstimationProperty`, {
      estimatePropertyId: id,
    });
  } catch (error) {
    console.log();
  }
};
const saveTaskProperties = async () => {
  await Promise.all(
    estimationProperties.value.map(async (data: any) => {
      await removeProperties(data.propertyId);
    })
  );
  const propertiesData = matchedAddresses.value.map((entry: any) => ({
    propertyId: entry.property.id,
  }));

  if (isMaterialsProperties.value) {
    store.dispatch(`${JOB_TEMPLATE_STORE}/setPhaseProperties`, {
      phaseIndex: props.phaseIndex,
      phaseProperties: propertiesData,
    });
  } else {
    store.dispatch(`${JOB_TEMPLATE_STORE}/setPhaseTaskProperties`, {
      phaseIndex: props.phaseIndex,
      itemIndex: props.taskIndex,
      taskProperties: propertiesData,
    });
  }

  emits("on-save-task-properties", matchedAddresses.value);
};
const currentJobDetails = computed(
  () => store.getters[`${JOBS_STORE}/getJobDetails`]
);

const addressesList = currentJobDetails.value.projectProperties.map(
  (property: any) => property.property
);

const handlePropertySelection = (selectedProperty: any) => {
  const addressList: any = [];
  matchedAddresses.value = currentJobDetails.value.projectProperties.filter(
    (property: any) => selectedProperty.includes(property.property.address)
  );

  addressList.value = matchedAddresses.value.map(
    (property: any) => property.property.addressData
  );
  if (addressList.value) {
    addressList.value.forEach((item: any) => {
      if (item) {
        const address = parseJSON(item);
        addressList.push({
          address: address.address || "",
          uprn: address.uprn || "",
          latlang: getLatLng(address),
          id: address.TOPOGRAPHY_LAYER_TOID || "",
          postcode: address.postcode || "",
        });
      }
    });
  }

  // if (item.addressData) {
  //   const address =
  //     typeof item.addressData === "string"
  //       ? JSON.parse(item.addressData)
  //       : item.addressData;
  //   latlang = address?.latlng;
  //   addressList.push({
  //     address: item.address,
  //     uprn: item.uprn,
  //     latlang,
  //     id: item.id,
  //     postcode: item.postcode,
  //   });
  // }
  addresses.value = addressList;
};

const isMaterialsProperties = computed(() => {
  return (
    estimateForm.value.projectStages[props.phaseIndex].stageType === "materials"
  );
});
const estimationProperties = computed(() => {
  if (!isMaterialsProperties.value) {
    return (
      (estimateForm.value.projectStages[props.phaseIndex].projectStageTasks[
        props.taskIndex
      ] &&
        estimateForm.value.projectStages[props.phaseIndex].projectStageTasks[
          props.taskIndex
        ].estimationPhaseTasksProperties) ||
      []
    );
  }
  return (
    (estimateForm.value.projectStages[props.phaseIndex]
      .estimationPhaseProperties &&
      estimateForm.value.projectStages[props.phaseIndex]
        .estimationPhaseProperties) ||
    []
  );
});

const mapKey = ref(0);

watch(
  addresses,
  (newAddresses, oldAddresses) => {
    // Check if addresses have actually changed
    if (newAddresses !== oldAddresses) {
      // Increment the key to force re-render

      mapKey.value++;
    }
  },
  { deep: true }
);
onBeforeMount(() => {
  const existingPropertyIds = estimationProperties.value.map(
    (data: any) => data.propertyId
  );

  matchedAddresses.value = currentJobDetails.value.projectProperties.filter(
    (property: any) => existingPropertyIds.includes(property.property.id)
  );
  selectedProperty.value = matchedAddresses.value.map(
    (property: any) => property.property.address
  );
  const addressList: any = [];
  if (matchedAddresses.value) {
    matchedAddresses.value.forEach((item: any) => {
      if (item.property.addressData) {
        const address = parseJSON(item.property.addressData);
        addressList.push({
          address: item.property.address || "",
          uprn: item.property.uprn || "",
          latlang: getLatLng(address),
          id: address.TOPOGRAPHY_LAYER_TOID || "",
          postcode: item.property.postcode || "",
        });
      }
    });
  }
  addresses.value = addressList;
});
const getLatLng = (addressData: string): LatLngExpression | undefined => {
  if (!addressData) return undefined;

  try {
    const unParsedData = parseJSON(addressData);
    const latlng: LatLngExpression = [
      unParsedData.LAT ? unParsedData.LAT : unParsedData.lat,
      unParsedData.LNG ? unParsedData.LNG : unParsedData.lng,
    ];
    return latlng;
  } catch (error) {
    console.error("Invalid address data:", error);
    return undefined;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(CommonDialog, {
    HeaderTittle: modelDetails.value.header,
    title: modelDetails.value.title,
    description: modelDetails.value.description,
    onClickBackButton: onClickBackButton,
    width: "560px",
    className: ['add_property_modal_box'],
    isShowHeader: false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value,
            ref_key: "propertyFormRef",
            ref: propertyFormRef
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_select, {
                    items: _unref(addressesList),
                    placeholder: "Please select Property",
                    rules: validation.value.propertyId,
                    modelValue: selectedProperty.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((selectedProperty).value = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (handlePropertySelection(selectedProperty.value)))
                    ],
                    variant: "outlined",
                    "item-title": "address",
                    "item-value": "address",
                    class: "input_field",
                    multiple: "",
                    "menu-props": { contentClass: 'custom__text__selector' }
                  }, null, 8, ["items", "rules", "modelValue"])
                ]),
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  onClick: saveTaskProperties
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("save")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ]),
      (addresses.value && addresses.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(), _createBlock(AddressMapComponent, {
              class: "pointer_events_none",
              latlng: [53.5809811, -0.6393335],
              addresses: addresses.value,
              key: mapKey.value
            }, null, 8, ["addresses"]))
          ]))
        : _createCommentVNode("", true),
      (!addresses.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchedAddresses.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "property-list"
          }, [
            _createVNode(_component_v_card, {
              variant: "tonal",
              class: "md:!tw-items-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(item?.property?.postcode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_icon, { class: "!tw-min-w-[15px] !tw-min-h-[15px]" }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createElementVNode("h4", _hoisted_15, _toDisplayString(item?.property?.address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(item.property.propertyCategory
                        ? item.property.propertyCategory
                        : "N/A"), 1),
                        _createTextVNode(" | "),
                        _createElementVNode("span", null, _toDisplayString(item.property.beds
                        ? `${item.property.beds} beds`
                        : "0 beds"), 1),
                        _createTextVNode(" | "),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.property.propertySize
                        ? `${item.property.propertySize} sqm`
                        : "0 sqm"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createElementVNode("h5", null, _toDisplayString(item.property.propertyType
                        ? item.property.propertyType
                        : "N/A"), 1)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024),
                _hoisted_20
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["HeaderTittle", "title", "description"]))
}
}

})